import { Component, OnInit } from '@angular/core';
import { slideInAnimation } from 'src/app/route-animate';
@Component({
  selector: 'app-csrsprojectdetail-page',
  templateUrl: './csrsprojectdetail-page.component.html',
  styleUrls: ['./csrsprojectdetail-page.component.css'],
  animations: [slideInAnimation],
})
export class CsrsprojectdetailPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
